import React, { useState, useEffect } from 'react';
import { ContentBox } from '../../Content/ContentBox';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { api_getClientAdminDetail, api_updateClientAdmin } from '../../../../api/apiAdmin';
import { ReqAccountAdminEdit, RespClientAdminDetail, ReqClientAdminEdit } from '../../../../item/ItemAccount';
import { CancelSubmitButton } from '../../Res/BaseButton';
import { SingleText, SingleInput, SingleRedio, isDisableItems } from '../../Res/BaseInput';
import Swal from 'sweetalert2';

export function ClientAdminEdit({ id }) {
    const [accountId, setAccountId] = useState(id)
    const [mRespAccountAdminDetail, setRespAccountAdminDetail] = useState(new RespClientAdminDetail())

    const [isDisable, setisDisable] = useState(0)
    const [nickName, setNickName] = useState("")
    const [email, setEmail] = useState("")

    useEffect(() => {
        if (id !== undefined && id !== accountId) {
            setAccountId(id)
        }
    }, [id])

    useEffect(() => {
        console.log("api_getAdminDetail")
        console.log(accountId)
        api_getClientAdminDetail({
            accountId,
            success: (result) => {
                console.log(result)
                var detail = new RespClientAdminDetail()
                detail.fromJson(result.detail)
                setRespAccountAdminDetail(detail)
                setNickName(detail.nickName)
                setEmail(detail.email)
                console.log(detail)
                setisDisable(detail.isDisable)
            },
            failure: (err) => {
                console.log(err)
            }
        })
    }, [accountId])

    function toDisable(isD) {
        //console.log(isD)
        setisDisable(isD)
    }

    function toCancel() {
        //window.location.assign("/AdminEdit/" + accountId);
        window.history.back()
    }
    function toEdit() {
        console.log(isDisable)
        console.log(mRespAccountAdminDetail.isDisable)
        if(nickName === ""){
            Swal.fire({
              type: 'error',
              title: '提醒',
              text: "暱稱不得為空",
            })
            return
        }
        var mReqClientAdminEdit = new ReqClientAdminEdit({
            accountId,
            email,
            nickName,
            isDisable: isDisable === mRespAccountAdminDetail.isDisable ? undefined : isDisable
        })
        console.log(mReqClientAdminEdit)
        api_updateClientAdmin({
            mReqClientAdminEdit,
            success:(jsonData)=>{
                Swal.fire({
                  type: 'success',
                  title: '提醒',
                  text: '編輯成功',
                }).then(()=>{
                    toCancel()
                })
            },
            failure:(err)=>{
                Swal.fire({
                  type: 'error',
                  title: '提醒',
                  text: err.message,
                })
            }
        })
    }

    var title = '申請人編輯'
    var content =
        <><div className="row">
            <div className="col-md-12">
                <SingleRedio title={"啟用狀態"}
                    arr={isDisableItems}
                    val={isDisable} action={setisDisable} />
                {/**
                <div className="col-md-4">
                    <p>啟用狀態</p>
                    <CheckIsEnable obj={mRespAccountAdminDetail} isDisabled={isDisable===1?true:false} setDisable={toDisable} />
                </div>
                         */}
                <div className="col-md-4">
                    <p>最近啟用日期</p>
                    <p>2019/04/05</p>
                </div>
                <div className="col-md-4">
                    <p>最近停用日期</p>
                    <p>2019/04/05</p>
                </div>
            </div>
        </div>
            <div className="hr-line-dashed"></div>
            <div className="row">
                <div className="col-md-12">
                    <SingleText title={"帳號"} val={mRespAccountAdminDetail.mobile} size={4} />
                    <SingleInput title={"暱稱"} val={nickName} action={setNickName} size={4} />
                    <SingleInput title={"電郵"} val={email} action={setEmail} size={4} />
                </div>
            </div>
            <div className="hr-line-dashed"></div>
            <div className="row">
                <div className="col-md-12">
                    <SingleText title={"總公司數"} val={mRespAccountAdminDetail.companyCount} size={4} />
                    <SingleText title={"啟用公司數"} val={mRespAccountAdminDetail.companyEnableCount} size={4} />
                    <SingleText title={"停用公司數"} val={mRespAccountAdminDetail.companyDisableCount} size={4} />
                </div>
            </div>
            <CancelSubmitButton cancelAction={toCancel} submitName={"儲存"} submitAction={toEdit} />
        </>
    return (
        <>
            <ContentBox title={title} content={content} hasDrawer={false} />
            <SystemPromptInput />
        </>
    )
}